import { render, staticRenderFns } from "./SpaceStatus.vue?vue&type=template&id=5aa0cc7e&"
import script from "./SpaceStatus.vue?vue&type=script&lang=ts&"
export * from "./SpaceStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports